// GOAT Productions — single source of truth for contact rails.
export const PHONE_NUMBER = "+61431731422";
export const WHATSAPP_NUMBER = "61431731422";
export const CONTACT_EMAIL = "enquiry@goatproductions.online";
